export class PageUtils {
  public static getPageVersion(frontasticData: any, defaultVersion: string | number): string | number {
    return frontasticData?.data?.dataSource?.pageVersion || defaultVersion;
  }
}
